export default function () {
    const body = document.getElementsByTagName('BODY')[0];
    const backdrop = document.getElementById('backdrop');
	const searchForm = document.getElementById('s');
	const searchPopover = document.querySelector('.c-topsearch__popover');
    let clickEvent = 'click';

    (function () {
        if ('ontouchstart' in document.documentElement) {
            clickEvent = 'touchend';
        }
    })();

    if (backdrop != null) {
        backdrop.addEventListener('click', function () {
            body.classList.remove('open-search');
			body.classList.remove('open-mainmenu');
			body.classList.remove('open-filter');
			body.classList.remove('open-twitter');
        });
    };

    document.addEventListener(clickEvent, function (event) {
        toggleMainMenu(event);
		toggleSearch(event);
		toggleTwitter(event);
        scrollDown(event);
        specialistModalOpen(event);
		specialistModalClose(event);
		scrollToSpecialists(event);
    });

    let timeOutVar;
    function removeAnimation(terminator = false) {
        if (terminator) {
            clearTimeout(timeOutVar);
        } else {
            timeOutVar = setTimeout(function () {
                body.classList.remove('animate-mainmenu');
            }, 640);
        }
    }

    function specialistModalOpen(event) {
        if (!event.target.matches('[data-modal="open"]')) return;
        event.preventDefault();
        const modalEl = event.target.nextElementSibling;
        if (modalEl) {
            modalEl.classList.add('show');
        }
    }

    function specialistModalClose(event) {
        if (!event.target.matches('[data-modal="close"]')) return;
        event.preventDefault();
        const modalEl = event.target.closest('.c-specialists__modal');
        if (modalEl) {
            modalEl.classList.remove('show');
        }
	}

	function scrollToSpecialists(event) {
		if (!event.target.matches('[data-scrollto="specialists"]')) return;
		const specialists = document.getElementById('specialists');
		if (specialists) {
			event.preventDefault();
			specialists.scrollIntoView();
		}
	}

    function scrollDown(event) {
        if (!event.target.matches('[data-event="scrolldown"]')) return;
        const heroEl = event.target.closest('.c-hero');
        if (heroEl) {
            const nextEl = heroEl.nextElementSibling;
            if (nextEl) {
                nextEl.scrollIntoView();
            }
        }
        event.target.classList.add('fadeout');
        event.target.setAttribute('aria-hidden', 'true');
    }

    function toggleMainMenu(event) {
        if (!event.target.matches('[data-event="toggleMainmenu"]')) return;
        event.preventDefault();
        body.classList.remove('open-search');
        body.classList.add('animate-mainmenu');

        if (body.classList.contains('open-mainmenu')) {
            body.classList.remove('open-mainmenu');
            removeAnimation(false);
        } else {
            body.classList.add('open-mainmenu');
            removeAnimation(true);
        }
    }

    function toggleSearch(event) {
        if (!event.target.matches('[data-event="toggleSearch"]')) return;
        event.preventDefault();
		body.classList.remove('open-mainmenu');

		if (body.classList.contains('open-search')) {
			body.classList.remove('open-search');
			searchPopover.setAttribute('aria-hidden', 'true');
		} else {
			body.classList.add('open-search');
			searchPopover.setAttribute('aria-hidden', 'false');
			setTimeout(focusSearch, 300);
		}
	}

	function toggleTwitter(event) {
		if (!event.target.matches('[data-event="toggleTwitter"]')) return;
		event.preventDefault();

		if (body.classList.contains('open-twitter')) {
			body.classList.remove('open-twitter');
			// searchPopover.setAttribute('aria-hidden', 'true');
		} else {
			body.classList.add('open-twitter');
			// searchPopover.setAttribute('aria-hidden', 'false');
		}
	}

    function focusSearch(event) {
        searchForm.focus();
	}

	window.addEventListener('keydown', function (event) {
		if (event.key === 'Esc' || event.key === 'Escape') {
			event.preventDefault();
			body.classList.remove('open-search');
			body.classList.remove('open-mainmenu');
			body.classList.remove('open-filter');
			body.classList.remove('open-twitter');
			const activeModal = document.querySelector('.c-specialists__modal.show');
			if (activeModal != null) {
				activeModal.classList.remove('show');
			}

			const activeFilter = document.querySelector('.c-filter__item--btn.active');
			if (activeFilter != null) {
				// activeFilter.classList.remove('active');
				activeFilter.click();
			}
		}
	}, true);
}
